import React from "react"
import { Link } from "gatsby"
import Logo from "../images/LOGO-BLS-2020-BLC.png"
import { StaticImage } from "gatsby-plugin-image"
import Drawer from "@material-ui/core/Drawer"
import Button from "@material-ui/core/Button"
import MenuIcon from "@material-ui/icons/Menu"
import styled from "styled-components"
import NestedList from "./HeaderMob/NestedList"

export const ImgStyles = styled.div`
  position: absolute;
  top: 58px;
  left: 50%;
  transform: translate(-50%, -50%);
  display: block;
`

export const ImgStyles2 = styled.div`
  background-color: var(--red);
  display: flex;
  justify-content: center;
  padding 0.5rem 0;
`

export const LineBrea = styled.div`
  width: 12px !important;
  height: 1px !important;
  margin: 0 auto !important;
  color: var(--red) !important;
  background-color: var(--white);
`

export const StyledUl = styled.div`
  text-align: center;
  ul:first-of-type {
    margin-top: 14px;
  }
  li:first-of-type {
    margin-top: 14px;
  }

  li {
    margin: 25px 0;
    list-style-type: none;
    font-family: var(--ff-heading);
    text-transform: uppercase;
  }
  a {
    font-size: 15px;
    color: var(--white);
  }
`

export default function TemporaryDrawer({ SearchOpen }) {
  const [state, setState] = React.useState({
    top: false,
  })

  const toggleDrawer = (anchor, open, jk) => event => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return
    }
    if (jk === "search") {
      SearchOpen()
    }
    setState({ ...state, [anchor]: open })
  }

  return (
    <React.Fragment key={"top"}>
      <ImgStyles>
        <Link to="/">
          <StaticImage
            src="../images/LOGO-BLS-2020-BLC.png"
            layout="fixed"
            height={70}
            width={140}
            loading="eager"
            className="logo"
            alt="bruno lafon selection logo"
          />
        </Link>
      </ImgStyles>

      <Button
        onClick={toggleDrawer("top", true)}
        className="w-[50px] h-[50px] text-white"
      >
        <MenuIcon
          style={{
            position: "fixed",
            fontSize: "32px",
            width: "32px",
            height: "32px",
            top: "56px",
            right: "40px",
            color: "white",
          }}
        />
      </Button>

      <Drawer
        anchor={"top"}
        open={state["top"]}
        onClose={toggleDrawer("top", false)}
        className="drawer"
      >
        <div style={{ backgroundColor: `var(--red)` }}>
          <ImgStyles2>
            <Link to="/" style={{ backgroundColor: "var(--red)" }}>
              <StaticImage
                src="../images/LOGO-BLS-2020-BLC.png"
                layout="fixed"
                height={70}
                width={140}
                loading="eager"
                className="logo"
                alt="bruno lafon selection logo"
              />
            </Link>
          </ImgStyles2>
          <LineBrea />
          <NestedList toggleDrawer={toggleDrawer} />
        </div>
      </Drawer>
    </React.Fragment>
  )
}
